import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06aaaa62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "plaque-reports" }
const _hoisted_2 = { class: "plaque-reports__creation" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Новый отчет ")
const _hoisted_4 = {
  key: 0,
  class: "plaque-reports__creation-text"
}
const _hoisted_5 = { class: "plaque-reports__reports" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_e_plaque_card = _resolveComponent("e-plaque-card")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        disabled: _ctx.isSubscriptionEnded,
        class: "plaque-reports__creation-button",
        round: "",
        type: "primary",
        onClick: _ctx.handleOpenReportCreationPage
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      (!_ctx.isPreviewMode && !_ctx.reports.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, " У пациента пока нет ни одного отчёта. Для создания отчета нажмите кнопку “Новый отчет” "))
        : _createCommentVNode("", true)
    ]),
    (_ctx.reports.length)
      ? (_openBlock(), _createBlock(_component_el_divider, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reports, (report) => {
        return (_openBlock(), _createBlock(_component_e_plaque_card, {
          key: report.id,
          active: _ctx.activeReportId === report.id,
          report: report,
          onClick: ($event: any) => (_ctx.handleOpenReportPage(report.id))
        }, null, 8, ["active", "report", "onClick"]))
      }), 128))
    ])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}